import {
  Navigate,
  Route,
  RouterProvider,
  createBrowserRouter,
  createRoutesFromElements
} from 'react-router-dom';
import ContactUs from '../contactUs/ContactUs';
import ErrorCard from '../../components/ErrorCard/ErrorCard';
import Faqs from '../faq/Faqs';
import Home from '../home/Home';
import PrivateRoute from '../../components/PrivateRoute/PrivateRoute';
import Profile from '../profile/Profile';
import { ROUTE_PROFILE_NAME } from '../../utils/constants';
import RootLayout from './RootLayout';

import SessionConfirm from '../sessionConfirm/SessionConfirm';
import Survey from '../survey/Survey';
import Terms from '../terms/Terms';
import { selectLocalSettings } from '../../ducks/settings';
import siteMessages from './siteMessages';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

interface Props {
  onClickLogin: () => void;
  onClickLogout: () => void;
}

const AppRoutes = (props: Props) => {
  const intl = useIntl();
  const lang = useSelector(selectLocalSettings);

  const router = createBrowserRouter(
    createRoutesFromElements(
      <>
        <Route
          path="/"
          element={
            <RootLayout
              onClickLogin={props.onClickLogin}
              onClickLogout={props.onClickLogout}
            />
          }
          errorElement={
            <ErrorCard
              text={intl.formatMessage({ ...siteMessages.ERROR_MESSAGE })}
            />
          }
        >
          {/* Redirections */}
          <Route
            path={`${ROUTE_PROFILE_NAME}`}
            element={<Navigate to={`/${lang}/${ROUTE_PROFILE_NAME}`} />}
          />
          <Route
            path={`${ROUTE_PROFILE_NAME}/personalinformation`}
            element={
              <Navigate
                to={`/${lang}/${ROUTE_PROFILE_NAME}/personalinformation`}
              />
            }
          />
          <Route
            path={`${ROUTE_PROFILE_NAME}/playtests`}
            element={
              <Navigate to={`/${lang}/${ROUTE_PROFILE_NAME}/playtests`} />
            }
          />
          <Route
            path={`${ROUTE_PROFILE_NAME}/gaminghabits`}
            element={
              <Navigate to={`/${lang}/${ROUTE_PROFILE_NAME}/gaminghabits`} />
            }
          />
          <Route
            path={`${ROUTE_PROFILE_NAME}/gamesplayed`}
            element={
              <Navigate to={`/${lang}/${ROUTE_PROFILE_NAME}/gamesplayed`} />
            }
          />
          <Route
            path="survey/:surveyId"
            element={<Navigate to={`/${lang}/survey/:surveyId`} />}
          />
          <Route
            path="preview/:surveyId"
            element={<Navigate to={`/${lang}/preview/:surveyId`} />}
          />
          <Route path="faq" element={<Navigate to={`/${lang}/faq`} />} />
          <Route
            path="contactus"
            element={<Navigate to={`/${lang}/contactus`} />}
          />
          <Route path="terms" element={<Navigate to={`/${lang}/terms`} />} />

          {/* Classique routes */}
          <Route path="/:lang">
            <Route path="terms" element={<Terms />} />
            <Route index element={<Home onClickLogin={props.onClickLogin} />} />
            <Route element={<PrivateRoute />}>
              <Route path={`${ROUTE_PROFILE_NAME}/*`} element={<Profile />} />
              <Route path="survey/:surveyId" element={<Survey />} />
              <Route path="session/:id/confirm" element={<SessionConfirm />} />
            </Route>
            <Route
              path="preview/:surveyId"
              element={<Survey isPreview={true} />}
            />
            <Route path="contactus" element={<ContactUs />} />
            <Route path="faq" element={<Faqs />} />
          </Route>
        </Route>
        <Route path="*" element={<Navigate to={`/${lang}/`} />} />
      </>
    )
  );

  return <RouterProvider router={router} />;
};

export default AppRoutes;
